const initReadingTime = () => {
 
  if (!document.querySelector(".reading-time")) {
    return;
  }

  const readingTimeBox = document.querySelector(".reading-time"); //The container in which the reading time estimate will be printed
  // Count the number of words in each text block
  const wordsInPost = wordCount(
    document.querySelectorAll(".text-block, .page-content p")
  );

  function wordCount(words) {
    let count = 0;
    for (let i = 0; i < words.length; i++) {
      count += words[i].textContent.split(" ").length;
    }
    return count;
  }

  const wpm = 250; //Average words per minute

  let readingTime = Math.ceil(wordsInPost / wpm);

  // Print the total reading time
  readingTimeBox.innerHTML = `Read Time: ${readingTime}m`;
};

export default initReadingTime;
